import template from './usersMyLeadGenerator.html';
import controller from './usersMyLeadGeneratorCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
};
